// ◉ xlVISION · Powering Business Together!
// © ExcelVision, Lda. — Braga, Portugal
// ( ·:·●●·:· ) xlVISION | Powering Business Together!
//
// ============================================================================
// Paleta de clientes — GERADA. NÃO EDITAR À MÃO.
// ============================================================================
//
// Origem: `tools/validador-paleta/validar.py --escrever`
// Alterar aqui à mão faz a paleta deixar de corresponder ao que foi validado.
//
// O QUE ESTAS CORES FAZEM
//   Dão a cada itinerário uma barra com cor, para o mapa se poder varrer. Com
//   ~40 clientes a cor **não identifica** o cliente — é um facto medido, e é o
//   erro que a folha actual comete (3 colisões de cor, 6 verdes distintos). A
//   identidade é a **sigla**, sempre visível; a segmentação é a **borda da
//   barra**; e para SEGUIR um cliente existe o foco, com 3 cores que essas sim
//   foram validadas como distinguíveis entre si sob visão cromática reduzida.
//
// `fundo` é a barra; `cap` é a aresta saturada de 3 px que lhe dá identidade.
// ============================================================================

export interface CorCliente {
  readonly fundo: string;
  readonly cap: string;
}


export const CLIENTES_CLARO: readonly CorCliente[] = [
  { fundo: '#b8defe', cap: '#1694df' },  //  0 · matiz 243.3° nivel 0
  { fundo: '#cbd8fe', cap: '#6985e7' },  //  1 · matiz 270.0° nivel 0
  { fundo: '#ddd1fe', cap: '#9676db' },  //  2 · matiz 296.7° nivel 0
  { fundo: '#f0caf4', cap: '#b769c0' },  //  3 · matiz 323.3° nivel 0
  { fundo: '#95dcf7', cap: '#0a91b4' },  //  4 · matiz 223.3° nivel 1
  { fundo: '#aed5fe', cap: '#1c86df' },  //  5 · matiz 250.0° nivel 1
  { fundo: '#c4cdfd', cap: '#6c76e2' },  //  6 · matiz 276.7° nivel 1
  { fundo: '#dbc4fc', cap: '#9866d1' },  //  7 · matiz 303.3° nivel 1
  { fundo: '#efbeea', cap: '#b75ab1' },  //  8 · matiz 330.0° nivel 1
  { fundo: '#7dd9e2', cap: '#0a8b94' },  //  9 · matiz 203.3° nivel 2
  { fundo: '#89d3f7', cap: '#0686b1' },  // 10 · matiz 230.0° nivel 2
  { fundo: '#a6cafd', cap: '#2978dd' },  // 11 · matiz 256.7° nivel 2
  { fundo: '#c0c1fe', cap: '#7067db' },  // 12 · matiz 283.3° nivel 2
  { fundo: '#d9b8f3', cap: '#9957c5' },  // 13 · matiz 310.0° nivel 2
  { fundo: '#eeb2dd', cap: '#b64a9f' },  // 14 · matiz 336.7° nivel 2
  { fundo: '#6cd0e1', cap: '#0d808f' },  // 15 · matiz 210.0° nivel 3
  { fundo: '#80c9f6', cap: '#057aad' },  // 16 · matiz 236.7° nivel 3
  { fundo: '#9ebffe', cap: '#376ad8' },  // 17 · matiz 263.3° nivel 3
  { fundo: '#beb5fa', cap: '#7458d0' },  // 18 · matiz 290.0° nivel 3
  { fundo: '#d8ace9', cap: '#9948b5' },  // 19 · matiz 316.7° nivel 3
  { fundo: '#eca6cf', cap: '#b33b8c' },  // 20 · matiz 343.3° nivel 3
  { fundo: '#5cc7e2', cap: '#08758b' },  // 21 · matiz 216.7° nivel 4
  { fundo: '#79bef5', cap: '#026fab' },  // 22 · matiz 243.3° nivel 4
  { fundo: '#9cb3fa', cap: '#435bd0' },  // 23 · matiz 270.0° nivel 4
  { fundo: '#bda8f2', cap: '#7649c3' },  // 24 · matiz 296.7° nivel 4
  { fundo: '#d7a0dd', cap: '#9839a3' },  // 25 · matiz 323.3° nivel 4
];

export const CLIENTES_ESCURO: readonly CorCliente[] = [
  { fundo: '#30546f', cap: '#4bb4fe' },  //  0 · matiz 243.3° nivel 0
  { fundo: '#424e72', cap: '#8aa6ff' },  //  1 · matiz 270.0° nivel 0
  { fundo: '#53496e', cap: '#b595fd' },  //  2 · matiz 296.7° nivel 0
  { fundo: '#604463', cap: '#d888e1' },  //  3 · matiz 323.3° nivel 0
  { fundo: '#0a5165', cap: '#18afd8' },  //  4 · matiz 223.3° nivel 1
  { fundo: '#284b6e', cap: '#41a3fe' },  //  5 · matiz 250.0° nivel 1
  { fundo: '#3f4570', cap: '#8793fd' },  //  6 · matiz 276.7° nivel 1
  { fundo: '#513f69', cap: '#b482f0' },  //  7 · matiz 303.3° nivel 1
  { fundo: '#5f3a5c', cap: '#d575ce' },  //  8 · matiz 330.0° nivel 1
  { fundo: '#034c51', cap: '#13a5b0' },  //  9 · matiz 203.3° nivel 2
  { fundo: '#024962', cap: '#0ea0d2' },  // 10 · matiz 230.0° nivel 2
  { fundo: '#24436d', cap: '#4491f9' },  // 11 · matiz 256.7° nivel 2
  { fundo: '#3d3c6c', cap: '#877ff6' },  // 12 · matiz 283.3° nivel 2
  { fundo: '#503562', cap: '#b26fe0' },  // 13 · matiz 310.0° nivel 2
  { fundo: '#5d3052', cap: '#d163b9' },  // 14 · matiz 336.7° nivel 2
  { fundo: '#01444d', cap: '#1097a9' },  // 15 · matiz 210.0° nivel 3
  { fundo: '#04415e', cap: '#0590cc' },  // 16 · matiz 236.7° nivel 3
  { fundo: '#233a69', cap: '#4b80f0' },  // 17 · matiz 263.3° nivel 3
  { fundo: '#3c3266', cap: '#876de8' },  // 18 · matiz 290.0° nivel 3
  { fundo: '#4e2b5a', cap: '#b05dcc' },  // 19 · matiz 316.7° nivel 3
  { fundo: '#5a2648', cap: '#cb51a1' },  // 20 · matiz 343.3° nivel 3
  { fundo: '#023c48', cap: '#0489a1' },  // 21 · matiz 216.7° nivel 4
  { fundo: '#01395b', cap: '#1081c4' },  // 22 · matiz 243.3° nivel 4
  { fundo: '#233065', cap: '#526ee4' },  // 23 · matiz 270.0° nivel 4
  { fundo: '#3b285f', cap: '#875cd7' },  // 24 · matiz 296.7° nivel 4
  { fundo: '#4c2151', cap: '#ab4cb7' },  // 25 · matiz 323.3° nivel 4
];

/** Quantas entradas existem. Clientes acima disto reutilizam cores — e
 *  isso e legitimo, porque a cor nao e a identidade. */
export const N_CORES_CLIENTE = 26;
